<div class="tw-flex tw-flex-col tw-h-full tw-bg-teal-200">
  <div class="tw-flex-1"></div>
  <p class="tw-text-200 tw-text-gray-800 tw-mb-2 tw-px-6 tw-capitalize"
     [class]="{
        'tw-text-100': userLanguagePreference !== 'hi',
        'tw-text-300': userLanguagePreference === 'hi',
        'tw-font-lexend': acqRebranding2025,
        'tw-font-medium': acqRebranding2025,
        'tw-font-body': !acqRebranding2025,
      }">
    <span i18n="@@hello">Hello</span>
    <span>&nbsp;{{user?.get('PatientName')?.split(" ")?.[0]}}</span>
  </p>
  <h1 [class]="{
        'tw-font-lexend': acqRebranding2025,
        'tw-tracking-normal': acqRebranding2025,
        'tw-font-body': !acqRebranding2025,
      }"
      class="tw-font-body tw-font-bold tw-text-800 tw-text-gray-800 tw-mb-8 tw-px-6"
      i18n="@@whatYouNeedHelpWith"> Tell us what you need help with </h1>
  <regimen-concern-selection class="tw-bg-white tw-rounded-t-5 tw-h-3/5"
                             [acqRebranding2025]="acqRebranding2025"
                             [concernClass]="selectedConcernClass"
                             [gender]='user?.get("Gender")'
                             (selectConcern)="updateConcern($event)"></regimen-concern-selection>
</div>